import React from 'react';
import { Field } from 'react-final-form';

import RenderDropdown from 'forms/RenderDropdown';
import { AppState } from 'services/types';
import { FertilizerProductId } from 'services/fertilizerProducts/types';
import { useSelector } from 'react-redux';
import { makeSelectOptions } from './selectors';

export interface Props {
    name: string;
    validate?: any;
    nullOnUnmount?: boolean;
    placeholder?: string;
    productId: FertilizerProductId;
}

export default function FertilizerEventProductRatePerUnitTypeDropdown(
    props: Props
): React.ReactElement | null {
    const {
        name,
        validate,
        nullOnUnmount = false,
        placeholder,
        productId
    } = props;

    const options = useSelector((state: AppState) =>
        makeSelectOptions()(state, props)
    );

    if (productId) {
        return (
            <Field
                component={RenderDropdown as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                name={name}
                label="Rate unit"
                fluid
                search
                selection
                selectOnBlur={false}
                validate={validate}
                options={options}
                nullOnUnmount={nullOnUnmount}
                placeholder={placeholder}
                defaultValue="Ha"
            />
        );
    }

    return null;
}
